module.exports = __webpack_public_path__ + "img/avatar5.89e3570f.png";